import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowBigDown: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M15 6v6h4l-7 7-7-7h4V6h6z' }]],
];

export default ArrowBigDown;
